import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';

import Console from '../helpers/Console';

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);

    this.state = { hasError: false };
  }

  componentDidCatch(error, info) {
    this.setState({ hasError: true });
    Console.log(info);
    if (window.Rollbar) {
      window.Rollbar.error(error);
    }
  }

  render() {
    const { hasError } = this.state;
    const {
      intl,
      children,
      invisible,
    } = this.props;

    if (hasError) {
      if (invisible) {
        return null;
      }

      return (
        <div className="center error-page">
          <h2>{intl.formatMessage({ defaultMessage: 'Oops, something went wrong!' })}</h2>
          <p>{intl.formatMessage({ defaultMessage: 'Please refresh your page and try again.' })}</p>
          <p>
            {intl.formatMessage({
              defaultMessage: 'If the issue still occurs, please <a>contact us</a>.',
            }, {
              a: (msg) => (
                <a href="mailto:help@stockpress.co">
                  {msg}
                </a>
              ),
            })}
          </p>
        </div>
      );
    }
    return children;
  }
}

ErrorBoundary.propTypes = {
  intl: PropTypes.object.isRequired,
  invisible: PropTypes.bool,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
};

ErrorBoundary.defaultProps = {
  invisible: false,
};

export default injectIntl(ErrorBoundary);
